import { AppAreaConfig } from '@/funnels/@types'

const appAreaConfig: AppAreaConfig = {
	appArea: 'female-water-fasting-al',
	landing: {
		ids: ['loader-water-balance-f'],
		route: {
			path: '/water-fasting-f-al',
			name: 'female-water-fasting-funnel-al',
		},
	},
	funnel: {
		id: 'ob-water-fasting-female-al',
		route: {
			path: '/water-fasting-f-al/ob/:page(.*)?',
			name: 'female-water-fasting-al',
		},
		slug: 'female-water-fasting-al',
		locale: ['en'],
	},
	prePaywall: {},
	paywall: {
		routeName: 'plan-water-fasting-f-al',
	},
	upsell: {
		routeNames: ['upsell-static-subscription-activated', 'upsell-f'],
	},
}

export default appAreaConfig
